<template>
  <transition
    name="drop-in"
    appear
  >
    <slot
      name="content"
    />
  </transition>
</template>

<script>
export default {
  name: 'OwalTransitionDropIn',
}
</script>

<style scoped>
.drop-in-enter-active {
  animation-name: drop-in;
  animation-duration: 700ms;
  animation-timing-function: ease-in;
}

.drop-in-leave-active, .drop-in-leave-to {
  animation-name: drop-in;
  animation-duration: 700ms;
  animation-timing-function: ease-in;
  animation-direction: reverse;
}

/* --- Drop In Animation --- */

@keyframes drop-in {
  0% {
    opacity: 0;
    transform: scale(1.5);
  }
  10% {
    transform: scale(1.45);
  }
  20% {

  }
  50% {
    opacity: .40;
  }
  60% {
    opacity: 1;
    transform: scale(1);
  }
  70% {
    opacity: 1;
    transform: scale(0.85);
  }
  80% {
    opacity: 1;
    transform: scale(1.15) translateY(0.1rem);
  }
  90% {
    opacity: 1;
    transform: scale(0.925) translateY(-0.075rem);
  }
  93% {
    opacity: 1;
  }
  96% {
    opacity: 1;
    transform: scale(0.9563) translateY(-0.0185);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

</style>
